<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="menus" :search="search">
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Menu',
  data: () => ({
    search: '',
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Menu', value: 'message' },
      { text: 'Actions', value: 'actions', sortable: false }
    ]
  }),
  computed: mapState({
    menus: state => state.menu.menus
  }),
  created () {
    this.$store.dispatch('menu/getMenus')
  }
}
</script>
